module.exports = __webpack_public_path__ + "img/swap_icon.fe9b51cf.svg";